<ngx-loading 
  [show]="loading" 
  [config]="loaderConfig"
  [template]="customLoadingTemplate">
</ngx-loading>

<ng-template #customLoadingTemplate>
  <div style="color: white; font-size: 16px; text-align: center; margin-top: 20px;">
    Loading...
  </div>
</ng-template>

<div class="sysadmin-wrapper">
    <div class="header-left">
        <p class="dashboard-subtitle">Welcome back, {{ currentUser?.username || 'Sys Admin' }}</p>
      </div>
  <!-- Metrics Overview -->
  <div class="overview-metrics-layout">
    <div class="performance-tile tile-primary">
      <div class="tile-figure">{{ totalUsers }}</div>
      <div class="tile-caption">Total Users</div>
    </div>
    
    <div class="performance-tile tile-secondary">
      <div class="tile-figure">{{ totalInstitutions }}</div>
      <div class="tile-caption">Institutions</div>
    </div>
    
    <div class="performance-tile tile-tertiary">
      <div class="tile-figure">{{ activeSessions }}</div>
      <div class="tile-caption">Active Sessions</div>
    </div>
    
    <div class="performance-tile tile-quaternary">
      <div class="tile-figure">{{ systemHealth }}</div>
      <div class="tile-caption">System Health</div>
    </div>
  </div>

  <!-- Quick Stats Section -->
  <div class="dashboard-panel">
    <h2 class="panel-heading">Quick Stats</h2>
    <div class="statistics-grid">
      <div class="stat-block">
        <strong>Daily Logins:</strong> {{ dailyLogins }}
      </div>
      <div class="stat-block">
        <strong>Storage:</strong> {{ storageUsed }}
      </div>
      <div class="stat-block">
        <strong>Response Time:</strong> {{ avgResponseTime }}
      </div>
    </div>
  </div>

  <!-- Recent Activities Section -->
  <div class="dashboard-panel">
    <h2 class="panel-heading">Recent Activities</h2>
    <div class="actions-timeline">
      <div class="timeline-entry" *ngFor="let activity of recentActivities">
        <div class="entry-timestamp">{{ activity.timestamp | date:'short' }}</div>
        <div class="entry-description">
          <strong>{{ activity.user }}</strong> - {{ activity.action }}
        </div>
        <div class="entry-badge" 
             [class.badge-positive]="activity.status === 'Success'"
             [class.badge-negative]="activity.status === 'Failed'">
          {{ activity.status }}
        </div>
      </div>
    </div>
  </div>

  <!-- Debug Information -->
  <div class="diagnostics-panel">
    <h3>Debug Information:</h3>
    <p>Component loaded at: {{ currentTime | date:'medium' }}</p>
    <p>Data initialized: {{ recentActivities.length }} activities loaded</p>
  </div>
</div>

 <!-- Footer -->
    <div class="slogin-footer-container">
      <p class="slogin-copyright">Techbridge | UITS © 2026 All rights reserved</p>
    </div>